import React, { FC } from 'react'
import { FormActions } from 'apps/marketplace/pages/facilities/constants'
import { ConfirmationModal } from 'transfix-ui'

export interface IDeleteFacilityConfirmationProps {
  onCancel: () => void
  onDelete: () => void
}

export const DeleteFacilityConfirmation: FC<IDeleteFacilityConfirmationProps> = ({
  onCancel,
  onDelete,
}) => {
  const actions = [
    {
      label: 'Cancel',
      type: FormActions.dismiss,
      action: onCancel,
    },
    {
      label: 'Yes, Delete',
      type: FormActions.confirm,
      action: onDelete,
    },
  ]
  return (
    <ConfirmationModal actions={actions} onClose={onCancel} open>
      Are you sure you want to delete this facility? This action cannot be reversed.
    </ConfirmationModal>
  )
}
